export function Annotate (annotation: string) {
  return (target: any, propertyName?: string) => {
    if (propertyName === undefined) {
      // annotate component
      return ((target, annotation: string) => {
        Annotate.set(`${target.name}`, annotation)
      })(target, annotation)
    } else {
      // annotate property
      return ((target, annotation: string, propertyName: string) => {
        Annotate.set(`${target.constructor.name}.${propertyName}`, annotation)
      })(target, annotation, propertyName)
    }
  }
}

// the compiled namespace falls back to a new object when the merged function is missing, which it never is
/* istanbul ignore next -- @preserve */
export namespace Annotate {
  let annotations: {
    [index: string]: string
  } = {}

  export function get (key: string) {
    return annotations[key]
  }

  export function set (key: string, annotation: string) {
    return annotations[key] = annotation
  }
}
